import Vue from 'vue'
import VueRouter from 'vue-router'
import Authentication from './Authentication.router'
import Login from './Login.router'
import Pages from './Pages.router'
import Gdpr from './Gdpr.router'


Vue.use(VueRouter);

// noinspection JSAnnotator
export default new VueRouter({
  mode: 'history',
  routes: [
    Authentication,
    Login,
    Pages,
    Gdpr
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js